// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SingleBooksDetails_main_container__rLUeQ {
    width: 100%;
    background: #1a1a1a;
    padding-top: 5rem;
  }
  
  .SingleBooksDetails_container__0N7Fm {
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px;
    color: white;
  }
  
  .SingleBooksDetails_header__iMFLw {
    display: flex;
    gap: 30px;
    margin-bottom: 10px;
  }
  .SingleBooksDetails_likeButton__k1WkY {
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
  }
  
  .SingleBooksDetails_likeButton__k1WkY:hover {
    transform: scale(1.05);
  }
  
  .SingleBooksDetails_likeButton__k1WkY:active {
    transform: scale(0.95);
  }
  
  .SingleBooksDetails_heartIcon__ZXPBR {
    margin-right: 5px;
    transition: all 0.3s ease;
  }
  
  .SingleBooksDetails_liked__B5q1w {
    animation: SingleBooksDetails_pulse__Y3ulY 0.4s ease-out;
  }
  
  .SingleBooksDetails_coverWrapper__7MPpU {
    flex: 0 0 250px;
  }
  
  .SingleBooksDetails_cover__YTPsM {
    width: 100%;
    height: auto;
    border-radius: 8px;
    object-fit: cover;
  }
  
  .SingleBooksDetails_info__faUc0 {
    flex: 1 1;
  }
  
  .SingleBooksDetails_title__CJL14 {
    font-size: 20px;
    margin: 0 0 10px 0;
  }
  
  .SingleBooksDetails_author__\\+\\+dJK {
    color: #888;
    margin-bottom: 20px;
  }
  
  .SingleBooksDetails_stats__6UHRJ {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
  }
  
  .SingleBooksDetails_stat__Qfi1T {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .SingleBooksDetails_icon__sXpyd {
    font-size: 20px;
  }
  
  .SingleBooksDetails_readButton__8oS-i {
    background: #e50914;
    color: white;
    border: none;
    padding: 12px 30px;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.3s;
  }
  .SingleBooksDetails_addLibrarybutton__56v6h {
    background: #0a7e27;
    color: white;
    border: none;
    padding: 12px 13px;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.3s;
  }
  .SingleBooksDetails_addButton__Mau60{
    color: white;
  }
  
  .SingleBooksDetails_readButton__8oS-i:hover {
    background: #f40d17;
  }
  
  .SingleBooksDetails_episodesSection__cQfa- {
    margin-top: 40px;
  }
  
  .SingleBooksDetails_episodesTitle__Dyg8m {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .SingleBooksDetails_episodesGrid__oK9eE {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
    padding: 10px 0;
  }
  
  .SingleBooksDetails_episodeCard__naw8j {
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.3s ease;
    display: flex;
  }
  
  .SingleBooksDetails_episodeCard__naw8j:hover {
    transform: translateY(-5px);
  }
  
  .SingleBooksDetails_episodeImageWrapper__YPD4j {
    aspect-ratio: 11 / 12;
    overflow: hidden;
  }
  
  .SingleBooksDetails_episodeImage__eLsxV {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
    cursor: pointer;
  }
  
  .SingleBooksDetails_episodeCard__naw8j:hover .SingleBooksDetails_episodeImage__eLsxV {
    transform: scale(1.05);
  }
  
  .SingleBooksDetails_episodeInfo__P1Pfp {
    padding: 15px;
  }
  
  .SingleBooksDetails_episodeName__fB4-b {
    margin: 0 0 5px 0;
    font-size: 18px;
  }
  
  .SingleBooksDetails_episodeSubtitle__3KTzo {
    color: #888;
    margin: 0;
    font-size: 14px;
  }
  
  .SingleBooksDetails_notFound__xCmkU {
    text-align: center;
    padding: 50px;
    font-size: 24px;
    color: white;
  }
  
  /* Responsive styles */
  @media (max-width: 768px) {
    .SingleBooksDetails_header__iMFLw {
      flex-direction: column;
    }
  
    .SingleBooksDetails_coverWrapper__7MPpU {
      flex: none;
      max-width: 200px;
      margin: 0 auto;
    }
  
    .SingleBooksDetails_stats__6UHRJ {
      flex-wrap: wrap;
    }
  
    .SingleBooksDetails_stat__Qfi1T {
      flex: 1 1 40%;
    }
  
    .SingleBooksDetails_episodesGrid__oK9eE {
      grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    }
  }
  
  @media (max-width: 480px) {
    .SingleBooksDetails_title__CJL14 {
      font-size: 18px;
    }
  .SingleBooksDetails_author__\\+\\+dJK {
      font-size: 16px;
    }
    .SingleBooksDetails_stats__6UHRJ span{
      font-size: 16px;
    }
    .SingleBooksDetails_coverWrapper__7MPpU{
      max-width: 200px;
      margin: 0 auto;
    }
    .SingleBooksDetails_stat__Qfi1T {
      flex: 1 1 100%;
    }
  
    .SingleBooksDetails_episodesGrid__oK9eE {
      grid-template-columns: 1fr;
    }
    .SingleBooksDetails_addLibrarybutton__56v6h {
      margin-top: 1rem;
    }
    .SingleBooksDetails_description__Ummvj p{
      font-size: 16px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/shortStories/SingleBooksDetails.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,wDAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;EAC7B;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,YAAY;EACd;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,UAAU;MACV,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,4DAA4D;IAC9D;EACF;;EAEA;IACE;MACE,eAAe;IACjB;EACF;MACI,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,gBAAgB;MAChB,cAAc;IAChB;IACA;MACE,cAAc;IAChB;;IAEA;MACE,0BAA0B;IAC5B;IACA;MACE,gBAAgB;IAClB;IACA;MACE,eAAe;IACjB;EACF","sourcesContent":[".main_container {\n    width: 100%;\n    background: #1a1a1a;\n    padding-top: 5rem;\n  }\n  \n  .container {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 20px;\n    color: white;\n  }\n  \n  .header {\n    display: flex;\n    gap: 30px;\n    margin-bottom: 10px;\n  }\n  .likeButton {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    transition: all 0.2s ease;\n  }\n  \n  .likeButton:hover {\n    transform: scale(1.05);\n  }\n  \n  .likeButton:active {\n    transform: scale(0.95);\n  }\n  \n  .heartIcon {\n    margin-right: 5px;\n    transition: all 0.3s ease;\n  }\n  \n  .liked {\n    animation: pulse 0.4s ease-out;\n  }\n  \n  .coverWrapper {\n    flex: 0 0 250px;\n  }\n  \n  .cover {\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n    object-fit: cover;\n  }\n  \n  .info {\n    flex: 1;\n  }\n  \n  .title {\n    font-size: 20px;\n    margin: 0 0 10px 0;\n  }\n  \n  .author {\n    color: #888;\n    margin-bottom: 20px;\n  }\n  \n  .stats {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 30px;\n  }\n  \n  .stat {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .icon {\n    font-size: 20px;\n  }\n  \n  .readButton {\n    background: #e50914;\n    color: white;\n    border: none;\n    padding: 12px 30px;\n    border-radius: 4px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background 0.3s;\n  }\n  .addLibrarybutton {\n    background: #0a7e27;\n    color: white;\n    border: none;\n    padding: 12px 13px;\n    border-radius: 4px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background 0.3s;\n  }\n  .addButton{\n    color: white;\n  }\n  \n  .readButton:hover {\n    background: #f40d17;\n  }\n  \n  .episodesSection {\n    margin-top: 40px;\n  }\n  \n  .episodesTitle {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n  \n  .episodesGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 20px;\n    padding: 10px 0;\n  }\n  \n  .episodeCard {\n    border-radius: 8px;\n    overflow: hidden;\n    transition: transform 0.3s ease;\n    display: flex;\n  }\n  \n  .episodeCard:hover {\n    transform: translateY(-5px);\n  }\n  \n  .episodeImageWrapper {\n    aspect-ratio: 11 / 12;\n    overflow: hidden;\n  }\n  \n  .episodeImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.3s ease;\n    cursor: pointer;\n  }\n  \n  .episodeCard:hover .episodeImage {\n    transform: scale(1.05);\n  }\n  \n  .episodeInfo {\n    padding: 15px;\n  }\n  \n  .episodeName {\n    margin: 0 0 5px 0;\n    font-size: 18px;\n  }\n  \n  .episodeSubtitle {\n    color: #888;\n    margin: 0;\n    font-size: 14px;\n  }\n  \n  .notFound {\n    text-align: center;\n    padding: 50px;\n    font-size: 24px;\n    color: white;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 768px) {\n    .header {\n      flex-direction: column;\n    }\n  \n    .coverWrapper {\n      flex: none;\n      max-width: 200px;\n      margin: 0 auto;\n    }\n  \n    .stats {\n      flex-wrap: wrap;\n    }\n  \n    .stat {\n      flex: 1 1 40%;\n    }\n  \n    .episodesGrid {\n      grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .title {\n      font-size: 18px;\n    }\n  .author {\n      font-size: 16px;\n    }\n    .stats span{\n      font-size: 16px;\n    }\n    .coverWrapper{\n      max-width: 200px;\n      margin: 0 auto;\n    }\n    .stat {\n      flex: 1 1 100%;\n    }\n  \n    .episodesGrid {\n      grid-template-columns: 1fr;\n    }\n    .addLibrarybutton {\n      margin-top: 1rem;\n    }\n    .description p{\n      font-size: 16px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_container": `SingleBooksDetails_main_container__rLUeQ`,
	"container": `SingleBooksDetails_container__0N7Fm`,
	"header": `SingleBooksDetails_header__iMFLw`,
	"likeButton": `SingleBooksDetails_likeButton__k1WkY`,
	"heartIcon": `SingleBooksDetails_heartIcon__ZXPBR`,
	"liked": `SingleBooksDetails_liked__B5q1w`,
	"pulse": `SingleBooksDetails_pulse__Y3ulY`,
	"coverWrapper": `SingleBooksDetails_coverWrapper__7MPpU`,
	"cover": `SingleBooksDetails_cover__YTPsM`,
	"info": `SingleBooksDetails_info__faUc0`,
	"title": `SingleBooksDetails_title__CJL14`,
	"author": `SingleBooksDetails_author__++dJK`,
	"stats": `SingleBooksDetails_stats__6UHRJ`,
	"stat": `SingleBooksDetails_stat__Qfi1T`,
	"icon": `SingleBooksDetails_icon__sXpyd`,
	"readButton": `SingleBooksDetails_readButton__8oS-i`,
	"addLibrarybutton": `SingleBooksDetails_addLibrarybutton__56v6h`,
	"addButton": `SingleBooksDetails_addButton__Mau60`,
	"episodesSection": `SingleBooksDetails_episodesSection__cQfa-`,
	"episodesTitle": `SingleBooksDetails_episodesTitle__Dyg8m`,
	"episodesGrid": `SingleBooksDetails_episodesGrid__oK9eE`,
	"episodeCard": `SingleBooksDetails_episodeCard__naw8j`,
	"episodeImageWrapper": `SingleBooksDetails_episodeImageWrapper__YPD4j`,
	"episodeImage": `SingleBooksDetails_episodeImage__eLsxV`,
	"episodeInfo": `SingleBooksDetails_episodeInfo__P1Pfp`,
	"episodeName": `SingleBooksDetails_episodeName__fB4-b`,
	"episodeSubtitle": `SingleBooksDetails_episodeSubtitle__3KTzo`,
	"notFound": `SingleBooksDetails_notFound__xCmkU`,
	"description": `SingleBooksDetails_description__Ummvj`
};
export default ___CSS_LOADER_EXPORT___;
